import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import Mission from "@/components/landing/Mission";
import Products from "@/components/landing/Products";
import Shields from "@/components/landing/Shields";
import Engine from "@/components/landing/Engine";
import Networks from "@/components/landing/Networks";
import Recognition from "@/components/landing/Recognition";
import CrazySports from "@/components/landing/CrazySports";
import Pilot from "@/components/landing/Pilot";
import Founder from "@/components/landing/Founder";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-root" className="bg-[#050505] text-white min-h-screen overflow-x-hidden">
      <Nav />
      <main>
        <Hero />
        <Ticker />
        <Mission />
        <Products />
        <Shields />
        <Engine />
        <Networks />
        <Recognition />
        <CrazySports />
        <Pilot />
        <Founder />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
